<template>
  <div>
    <four-oh-four />

    <info-alt />

    <home-footer />
  </div>
</template>

<script>
  import FourOhFour from '@/views/sections/404'
  import InfoAlt from '@/views/sections/InfoAlt'
  import HomeFooter from '@/layouts/home/Footer'

  export default {
    name: 'BaseFourOhFour',

    metaInfo () {
      return {
        title: 'Oops! No Page Found',
      }
    },

    components: {
      FourOhFour,
      InfoAlt,
      HomeFooter,
    },
  }
</script>
